import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule }   from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BrainStormComponent } from '../brain-storm/brain-storm.component';
import { BSDayViewComponent } from '../brain-storm/bs-day-view/bs-day-view.component';
import { BSMonthViewComponent } from '../brain-storm/bs-month-view/bs-month-view.component';
import { DailyActComponent } from '../daily-act/daily-act.component'
import { ProdHighComponent } from '../daily-act/prod-high/prod-high.component'
import { MatShortComponent } from '../daily-act/mat-short/mat-short.component'
import { DlvyPlanComponent } from "app/daily-act/dlvy-plan/dlvy-plan.component";
import { CustInspPlanComponent } from "app/daily-act/cust-insp-plan/cust-insp-plan.component";
import { GrnSticPlanComponent } from "app/daily-act/grn-stic-plan/grn-stic-plan.component";
import { InprQualIssuComponent } from "app/daily-act/inpr-qual-issu/inpr-qual-issu.component";
import { CcrpStatMonComponent } from "app/daily-act/ccrp-stat-mon/ccrp-stat-mon.component";
import { ProdStatMonComponent } from "app/daily-act/prod-stat-mon/prod-stat-mon.component";
import { ManPowAllocComponent } from "app/daily-act/man-pow-alloc/man-pow-alloc.component";
import { PolStkRvwComponent } from "app/daily-act/pol-stk-rvw/pol-stk-rvw.component";
import { GembaCardComponent } from "app/gemba-card/gemba-card.component";
import { SafetyAppComponent } from 'app/gemba-card/safety-app/safety-app.component';
import { NwcmTreeComponent } from 'app/nwcm-tree/nwcm-tree.component';
import { SummaryPageComponent } from 'app/summary-page/summary-page.component';
import { FinishedGoodsComponent } from '../daily-act/finished-goods/finished-goods.component';
import { MonthlyProdPlanComponent } from 'app/daily-act/monthly-prod-plan/monthly-prod-plan.component';

export const routes: Routes = [
  {
    path:'summary',component:SummaryPageComponent,pathMatch:'full'
  },
  { 
    path: 'brain-storm', component: BrainStormComponent, children: [
        {path: 'daywise', component: BSDayViewComponent},
        {path: 'monthwise', component: BSMonthViewComponent}
    ]
  },
  {
    path: 'daily-act',component:DailyActComponent, children: [
        {path: 'prod-high', component:ProdHighComponent},
        {path: 'mat-short', component:MatShortComponent},
        {path: 'dlvy-plan', component:DlvyPlanComponent},
        {path: 'cust-insp-plan', component:CustInspPlanComponent},
        {path: 'grn-stic-plan', component:GrnSticPlanComponent},
        {path: 'inpr-qual-issu', component:InprQualIssuComponent},
        {path: 'ccrp-stat-mon', component:CcrpStatMonComponent},
        {path: 'prod-stat-mon', component:ProdStatMonComponent},
        {path: 'man-pow-alloc', component:ManPowAllocComponent},
        {path: 'pol-stk-rvw', component:PolStkRvwComponent},
        {path: 'finished-goods',component: FinishedGoodsComponent},
        {path: 'monthly-prod-plan',component: MonthlyProdPlanComponent}
    ]
  },
  {
    path:'gemba-card', component:GembaCardComponent, pathMatch: 'full'
  },
  {
    path:'nwcm-tree', component:NwcmTreeComponent, pathMatch: 'full'
  },
  { path: '', redirectTo: 'summary', pathMatch: 'full'}
  
]; 
@NgModule({
  imports: [BrowserModule,FormsModule,RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RoutingModule { }
